/**
 * Origem Flow: serviço do hub de Clipes (/api/clips/*).
 */
export default (client) => {
  return {
    fetchAll(workspaceId) {
      return client.get(`/clips/workspace/${workspaceId}/`)
    },
    create(workspaceId, { title, fileName, fileUrl }) {
      return client.post(`/clips/workspace/${workspaceId}/`, {
        title,
        file_name: fileName,
        file_url: fileUrl,
      })
    },
    // Origem Flow: upload do vídeo direto para o diretório privado de
    // clipes + criação do clipe em uma chamada (substitui user-files).
    upload(workspaceId, file, title) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('title', title)
      return client.post(`/clips/workspace/${workspaceId}/upload/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    },
    // Origem Flow: link de compartilhamento assinado, com validade.
    shareLink(clipId) {
      return client.get(`/clips/${clipId}/share-link/`)
    },
    update(clipId, values) {
      return client.patch(`/clips/${clipId}/`, values)
    },
    delete(clipId) {
      return client.delete(`/clips/${clipId}/`)
    },
  }
}
